import create from "zustand";
import { devtools } from "zustand/middleware";

export interface IPageInfo {
  pageName: string;
  firstLevelPageName: string;
  secondLevelPageName: string;
  pageRefferer: string;
  isCoveredByInsurance: string;
  insuranceName: string;
  currentPath: string;
  insuranceCoveredTargetGroups: string[];
}

export type PageInfo = {
  pageInfo: any;
  pageInfoLoading: boolean;
  setPageInfo: (info: IPageInfo) => void;
};
export const usePageInfo = create<PageInfo>(
  devtools(
    (set) => ({
      pageInfo: {
        pageName: "",
        firstLevelPageName: "",
        secondLevelPageName: "",
        pageRefferer: "",
        isCoveredByInsurance: "",
        insuranceName: "",
        currentPath: "",
        insuranceCoveredTargetGroups: [],
      },
      pageInfoLoading: true,
      setPageInfo: (pageInfo: any) =>
        set((_state: PageInfo) => ({ pageInfo, pageInfoLoading: false })),
    }),
    { name: "PAGE_INFO" },
  ),
);
